import React, { useEffect, useState } from "react";
import api from "../../services/api";

import PageHeader from "../components/PageHeader";
import SearchBar from "../components/SearchBar";
import DataTable from "../components/DataTable";
import Loader from "../components/Loader";
import ConfirmModal from "../components/ConfirmModal";

import API_URL from "../../config";

const SubscriptionPlans = () => {

    const [loading, setLoading] = useState(true);

    const [plans, setPlans] = useState([]);

    const [filteredPlans, setFilteredPlans] = useState([]);

    const [search, setSearch] = useState("");

    const [showModal, setShowModal] = useState(false);

    const [editingPlan, setEditingPlan] = useState(null);

    const [deleteId, setDeleteId] = useState(null);

    const [formData, setFormData] = useState({

        plan_name: "",

        price: "",

        validity_days: "",

        job_limit: "",

        featured_jobs: "",

        resume_access: false,

        candidate_unlock_limit: "",

        priority_support: false,

        company_branding: false

    });

    useEffect(() => {

        fetchPlans();

    }, []);

    useEffect(() => {

        filterPlans();

    }, [plans, search]);

    const fetchPlans = async () => {

        try {

            setLoading(true);

            const response = await api.get("/admin/subscription-plans");

            setPlans(response.data);

            setFilteredPlans(response.data);

        } catch (error) {

            console.error("Error fetching subscription plans:", error);

        } finally {

            setLoading(false);

        }

    };

    const filterPlans = () => {

        if (!search.trim()) {

            setFilteredPlans(plans);

            return;

        }

        const keyword = search.toLowerCase();

        const filtered = plans.filter((plan) =>

            plan.plan_name?.toLowerCase().includes(keyword) ||

            String(plan.price).includes(search) ||

            String(plan.validity_days).includes(search)

        );

        setFilteredPlans(filtered);

    };

    const handleInputChange = (e) => {

        const {

            name,

            value,

            type,

            checked

        } = e.target;

        setFormData({

            ...formData,

            [name]:

                type === "checkbox"

                    ? checked

                    : value

        });

    };

    const resetForm = () => {

        setEditingPlan(null);

        setFormData({

            plan_name: "",

            price: "",

            validity_days: "",

            job_limit: "",

            featured_jobs: "",

            resume_access: false,

            candidate_unlock_limit: "",

            priority_support: false,

            company_branding: false

        });

    };

    const openEdit = (plan) => {

        setEditingPlan(plan);

        setFormData({

            ...plan

        });

        setShowModal(true);

    };

    const handleDelete = async () => {

        if (!deleteId) return;

        try {

            await api.delete(

                `${API_URL}/admin/subscription-plans/${deleteId}`

            );

            fetchPlans();

        } catch (error) {

            console.error("Delete failed:", error);

        }

    };

   const columns = [
    { key: "id", label: "ID" },
    { key: "plan_name", label: "Plan Name" },
    { key: "price", label: "Price" },
    { key: "job_limit", label: "Jobs" },
    { key: "validity_days", label: "Validity" },
    { key: "candidate_unlock_limit", label: "Candidate Unlocks" },
    { key: "resume_access", label: "Resume Access" },
    { key: "priority_support", label: "Priority Support" }
];
        if (loading) {

        return (

            <Loader
                fullScreen={true}
                text="Loading Subscription Plans..."
            />

        );

    }

    return (

       <div className="space-y-6">

            <PageHeader
    title="Subscription Plans"
    subtitle="Manage all subscription plans"
    showButton={true}
    buttonText="Add Plan"
    onButtonClick={() => {
        resetForm();
        setShowModal(true);
    }}
    breadcrumb={[
        { label: "Dashboard", link: "/admin" },
        { label: "Subscription Plans" }
    ]}
/>

            <div className="bg-white rounded-3xl shadow-lg p-6">

    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">

        <SearchBar
            value={search}
            onChange={setSearch}
            onClear={() => setSearch("")}
            placeholder="Search subscription plans..."
        />

    </div>

    <DataTable
        title="Subscription Plans"
        columns={columns}
        data={filteredPlans}
        emptyMessage="No subscription plans found."
        actions={(plan) => (

            <div className="flex justify-center gap-2">

                <button
                    onClick={() => openEdit(plan)}
                    className="px-3 py-2 rounded-xl bg-yellow-100 text-yellow-700 hover:bg-yellow-200 transition"
                >
                    Edit
                </button>

                <button
                    onClick={() => setDeleteId(plan.id)}
                    className="px-3 py-2 rounded-xl bg-red-100 text-red-600 hover:bg-red-200 transition"
                >
                    Delete
                </button>

            </div>

        )}
    />

</div>

           <ConfirmModal
    open={deleteId !== null}
    title="Delete Subscription Plan"
    message="Are you sure you want to delete this subscription plan?"
    confirmText="Delete"
    onConfirm={() => {
        handleDelete();
        setDeleteId(null);
    }}
    onCancel={() => setDeleteId(null)}
/>
                                            {showModal && (

                                <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 overflow-auto">

                                <div className="bg-white rounded-3xl shadow-2xl w-full max-w-4xl p-8 my-10">

                                <div className="flex justify-between items-center mb-8">

                                <h2 className="text-2xl font-bold">

                                {editingPlan ? "Edit Subscription Plan" : "Add Subscription Plan"}

                                </h2>

                                <button
                                    onClick={() => {
                                        setShowModal(false);
                                        resetForm();
                                    }}
                                    className="text-2xl text-gray-500 hover:text-red-500"
                                >
                                    ✕
                                </button>

                            </div>

                            <div className="modal-body"></div>
                                                    <form
                                onSubmit={async (e) => {

                                    e.preventDefault();

                                    try {

                                        if (editingPlan) {

                                            await api.put(

                                                `${API_URL}/admin/subscription-plans/${editingPlan.id}`,

                                                formData

                                            );

                                        } else {

                                            await api.post(

                                                `${API_URL}/admin/subscription-plans`,

                                                formData

                                            );

                                        }

                                        setShowModal(false);

                                        resetForm();

                                        fetchPlans();

                                    } catch (error) {

                                        console.error(
                                            "Error saving subscription plan:",
                                            error
                                        );

                                    }

                                }}
                            >

                                <div className="row">

                                    <div className="col-md-6 mb-3">

                                        <label className="form-label">

                                            Plan Name

                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            name="plan_name"
                                            value={formData.plan_name}
                                            onChange={handleInputChange}
                                            required
                                        />

                                    </div>

                                    <div className="col-md-6 mb-3">

                                        <label className="form-label">

                                            Price (₹)

                                        </label>

                                        <input
                                            type="number"
                                            className="form-control"
                                            name="price"
                                            value={formData.price}
                                            onChange={handleInputChange}
                                            required
                                        />

                                    </div>

                                    <div className="col-md-6 mb-3">

                                        <label className="form-label">

                                            Validity (Days)

                                        </label>

                                        <input
                                            type="number"
                                            className="form-control"
                                            name="validity_days"
                                            value={formData.validity_days}
                                            onChange={handleInputChange}
                                            required
                                        />

                                    </div>

                                    <div className="col-md-6 mb-3">

                                        <label className="form-label">

                                            Job Limit

                                        </label>

                                        <input
                                            type="number"
                                            className="form-control"
                                            name="job_limit"
                                            value={formData.job_limit}
                                            onChange={handleInputChange}
                                            required
                                        />

                                    </div>

                                    <div className="col-md-6 mb-3">

                                        <label className="form-label">

                                            Featured Jobs

                                        </label>

                                        <input
                                            type="number"
                                            className="form-control"
                                            name="featured_jobs"
                                            value={formData.featured_jobs}
                                            onChange={handleInputChange}
                                        />

                                    </div>

                                    <div className="col-md-6 mb-3">

                                        <label className="form-label">

                                            Candidate Unlock Limit

                                        </label>

                                        <input
                                            type="number"
                                            className="form-control"
                                            name="candidate_unlock_limit"
                                            value={formData.candidate_unlock_limit}
                                            onChange={handleInputChange}
                                        />

                                    </div>

                                    <div className="col-md-4 mb-3">

                                        <div className="form-check mt-4">

                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="resumeAccess"
                                                name="resume_access"
                                                checked={formData.resume_access}
                                                onChange={handleInputChange}
                                            />

                                            <label
                                                className="form-check-label"
                                                htmlFor="resumeAccess"
                                            >

                                                Resume Access

                                            </label>

                                        </div>

                                    </div>

                                    <div className="col-md-4 mb-3">

                                        <div className="form-check mt-4">

                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="prioritySupport"
                                                name="priority_support"
                                                checked={formData.priority_support}
                                                onChange={handleInputChange}
                                            />

                                            <label
                                                className="form-check-label"
                                                htmlFor="prioritySupport"
                                            >

                                                Priority Support

                                            </label>

                                        </div>

                                    </div>

                                    <div className="col-md-4 mb-3">

                                        <div className="form-check mt-4">

                                            <input
                                                type="checkbox"
                                                className="form-check-input"
                                                id="companyBranding"
                                                name="company_branding"
                                                checked={formData.company_branding}
                                                onChange={handleInputChange}
                                            />

                                            <label
                                                className="form-check-label"
                                                htmlFor="companyBranding"
                                            >

                                                Company Branding

                                            </label>

                                        </div>

                                    </div>

                                </div>

                                <div className="modal-footer">

                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        onClick={() => {

                                            setShowModal(false);

                                            resetForm();

                                        }}
                                    >

                                        Cancel

                                    </button>

                                    <button
                                        type="submit"
                                        className="btn btn-primary"
                                    >

                                        {editingPlan
                                            ? "Update Plan"
                                            : "Save Plan"}

                                    </button>

                                </div>

                            </form>

                        </div>

                    </div>

            )}
                    </div>

    );

};

export default SubscriptionPlans;